import React, { createContext, useContext, useMemo } from 'react';

import type { GlobalPromptHandler } from './GlobalPromptHandler.tsx';

interface GlobalPromptContextType {
	globalPromptHandler: GlobalPromptHandler;
}

const GlobalPromptContext = createContext<GlobalPromptContextType | null>(null);

export const useGlobalPromptContext = () => useContext(GlobalPromptContext);

interface GlobalPromptContextProviderProps extends React.PropsWithChildren {
	globalPromptHandler: GlobalPromptHandler;
}

export const GlobalPromptContextProvider: React.FC<GlobalPromptContextProviderProps> = ({
	children,
	globalPromptHandler,
}) => {
	const contextValue = useMemo(
		(): GlobalPromptContextType => ({
			globalPromptHandler,
		}),
		[globalPromptHandler],
	);

	return (
		<GlobalPromptContext.Provider value={contextValue}>{children}</GlobalPromptContext.Provider>
	);
};
